
$(function() {
  var pageTitle   = document.title;
  var pageUrl     = location.href;

  $('.share li').click(function(){
    var shareName = $(this).attr('class').split(' ')[0];
    switch(shareName) {
    case 'twitter':
      OpenShareUrl('https://twitter.com/share?url=' +encodeURIComponent(pageUrl) + '&amp;text= ' + encodeURIComponent(pageTitle)); //+ '&amp;hashtags=TRESnl');
      break;
    case 'facebook':
      OpenShareUrl('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(pageUrl) + '&amp;title=' + encodeURIComponent(pageTitle));
      break;
    case 'linkedin':
      OpenShareUrl('http://www.linkedin.com/shareArticle?mini=true&amp;url=' + encodeURIComponent(pageUrl));
      break;
    case 'email':
      OpenShareUrl('mailto:?subject=' + pageTitle + '&body=' + pageUrl);
      break;
    case 'whatsapp':
      OpenShareUrl('whatsapp://send?text=' + pageTitle + ' ' + pageUrl);
      break;
    }
  });

  function OpenShareUrl(openLink){
    window.open(openLink, 'Share This Link', '_blank');
    return false;
  }

  if (!navigator.userAgent.match(/iPhone|Android/i)) {
    $('.share .whatsapp').addClass('hidden');
  }
});
